import { openAdjuntoEnNuevaPestana } from "@/lib/openAdjuntoEnNuevaPestana";

/**
 * Lista de adjuntos de una respuesta de cliente (revisiones), en data URL.
 * Mismo patrón visual que las respuestas con archivos en formularios (blob para data:).
 */
export default function RevisionReplyAdjuntos({ adjuntos, className = "" }) {
  const list = Array.isArray(adjuntos) ? adjuntos : [];
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`.trim()}>
      {list.map((f, i) => {
        const url = f?.data_url || f?.url;
        if (!url || typeof url !== "string") return null;
        const name = (f.nombre || f.name || `archivo-${i + 1}`).trim();
        const mime = f.mime || f.type || "";
        const isImage = typeof mime === "string" && mime.startsWith("image/");
        return (
          <button
            key={`${name}-${i}`}
            type="button"
            onClick={() => openAdjuntoEnNuevaPestana(url)}
            className="inline-flex items-center gap-2 rounded-md border bg-muted/50 px-2.5 py-1.5 text-xs hover:bg-muted text-left cursor-pointer"
          >
            {isImage ? (
              <img src={url} alt={name} className="h-8 w-8 rounded object-cover border pointer-events-none" />
            ) : null}
            <span className="max-w-[240px] truncate">{name}</span>
          </button>
        );
      })}
    </div>
  );
}
